import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

   
    /** 获取系统信息设置 **/
    GET_SETTING_INFO(data) {
        controller='EsSetting';
        action='GetSetting';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 保存系统信息设置 **/
    SAVE_SETTING_INFO(data) {
        controller='EsSetting';
        action='UpdateSettingInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 同步宠市宠物信息 **/
    SYNC_PET_INFO(data) {
        controller='EsChongShiMove';
        action='GetChongShiData';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取微信小程序设置 **/
    GET_XCX_SETTING(data) {
        controller='EsSetting';
        action='GetXcxAppSetting';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 保存微信小程序设置 **/
    SAVE_XCX_SETTING(data) {
        controller='EsSetting';
        action='UpdateXcxAppSetting';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取微信公众号设置 **/
    GET_Wx_GZH_SETTING(data) {
        controller='EsSetting';
        action='GetGzhAppSetting';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 保存微信公众号设置 **/
    SAVE_Wx_GZH_SETTING(data) {
        controller='EsSetting';
        action='UpdateGzhAppSetting';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


}